function openTabFeed(evt, sectionId, tabName) {
  // get all elements with class="tabcontent" and hide them except the first one
  const tabcontent = document.getElementsByClassName(
    "products-feed__tabcontent--" + sectionId
  );
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // get all elements with class="tablinks" and remove the class "active" except the first one
  const tablinks = document.getElementsByClassName(
    "products-feed__tablinks--" + sectionId
  );
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(
      " active",
      ""
    );
  }

  // show the current tab, and add an "active" class to the button that opened the tab
  const panel = document.getElementById(tabName);
  if (panel) {
    panel.style.display = "block";
    refreshTabSwipers(panel);
  }

  if (evt && evt.currentTarget) {
    evt.currentTarget.className += " active";
  }
}

// A Swiper that initialises inside a display:none tab measures zero width, so it
// registers no slides and never lays them out. The slides then render full width
// and stacked, and the arrows do nothing. Re-measure once the tab is visible.
// Tabs in one section also share the same arrow selectors, so the navigation is
// rebound to whichever slider is currently on screen.
function refreshTabSwipers(panel) {
  if (!panel) return;

  const run = function () {
    panel
      .querySelectorAll("swiper-component, .swiper")
      .forEach(function (el) {
        const instance = el.swiper;
        if (!instance || instance.destroyed) return;
        try {
          instance.update();
          if (
            instance.navigation &&
            typeof instance.navigation.update === "function"
          ) {
            instance.navigation.update();
          }
        } catch (e) {
          // a slider that is not ready yet is picked up by the retry below
        }
      });
  };

  // force a layout read so the panel we just revealed reports real dimensions
  void panel.offsetHeight;
  run();
  // retry once for sliders whose images finish laying out a beat later
  setTimeout(run, 100);
}

// show the first tabs by default on load - data-default-open
document.querySelectorAll("[data-default-open]").forEach(el => {
  el.click();
});
window.addEventListener("shopify:section:load", () => {
  document.querySelectorAll("[data-default-open]").forEach(el => {
    el.click();
  });
});
